module.exports = __webpack_public_path__ + "images/180_320.jpg";